import script from "./FormSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormSelect.vue?vue&type=script&setup=true&lang=ts"

import "./FormSelect.vue?vue&type=style&index=0&id=5b40b4db&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b40b4db"]])

export default __exports__